import React from "react";
import { Navigate } from "react-router-dom";
import { authRoutes, mainRoutes, invalidRoutes } from "./AllRoutes";
import { AuthLayout, MainLayout } from "../layout";
import Page404 from "../pages/Page404";
import { routes } from "../helpers/constants";

const getRoutes = (user) => {
  return [
    {
      path: routes.homepage,
      element: !user ? <AuthLayout /> : <Navigate to={routes.takeDetails} />,
      children: authRoutes,
    },
    {
      path: routes.homepage,
      element: user ? <MainLayout /> : <Navigate to={routes.login} />,
      children: mainRoutes,
    },
    {
      path: "",
      element: !user ? (
        <Navigate to={routes.login} />
      ) : user ? (
        <Navigate to={routes.takeDetails} />
      ) : (
        <Page404 />
      ),
      children: invalidRoutes,
    },
  ];
};

export default getRoutes;
